<pxc-card-details class="block h-full">
  <div class="ml-5 flex flex-col gap-1">
    <pxc-patient-data data-testid="patient-details" size="small" [patient]="patient">
      <ng-content />
      <ng-container slot="additional-data">
        <ng-content select="[slot=details]" />
      </ng-container>
      <ng-content />
      <ng-container additional-data>
        <ng-content select="[details]" />
      </ng-container>
    </pxc-patient-data>
    @if (displayLastActivity) {
      <span appearance="neutral" tuiBadge tuiStatus>
        {{ patient.lastActivity | lastActivity }}
      </span>
    }
  </div>
  <ng-container ngProjectAs="[dropdown-menu]">
    <ng-content select="[trailing]" />
  </ng-container>
  @if (actions) {
    <pxc-action-buttons
      *showIfUserAuthorizedForPatient="patient"
      data-testid="menu-actions"
      dropdown-menu
      [actions]="actions"
      [entity]="patient" />
  }
</pxc-card-details>

<pxc-patient-avatar class="absolute -left-4 top-4" data-testid="patient-avatar" size="small" [patient]="patient" />
